module.exports = __webpack_public_path__ + "img/diko-logo.a8942301.png";